import * as _brand from 'static/icons/brand';
import * as _light from 'static/icons/light';
import * as _regular from 'static/icons/regular';
import * as _solid from 'static/icons/solid';
import * as _duotone from 'static/icons/duotone';
export const light = _light;
export const brand = _brand;
export const regular = _regular;
export const solid = _solid;
export const duotone = _duotone;
